// extracted by mini-css-extract-plugin
module.exports = {"wz6pjyl":"wz6pjyl","fun271e":"fun271e"};